<template>
	<!-- <footerPage /> -->
</template>

<script>
	import footerPage from  "../../USER/public/home/home_part9.vue";
	export default {
		name: 'PageNavigation',
		data(){
			return {
			}
		},
		components: {
			footerPage,
		},
		props: [],
		methods:{

		},
		mounted(){
		},
	}
</script>

<style scope>
</style>
